/*
 * @Author: 御坂网络服务 wangweigang@gooagoo.com
 * @Date: 2022-05-05 14:40:07
 * @LastEditors: Lsx
 * @LastEditTime: 2022-05-13 10:37:14
 * @FilePath: \parkinglot-web\src\util\request.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import axios from "axios";
import Vue from "vue";
import qs from "qs";
// import { Dialog } from "vant";
import { Toast, Dialog } from 'vant'
// const apiRequest = axios.create({})
// axios.defaults.withCredentials = true
// 请求拦截
axios.interceptors.request.use(config => {
/*  Vue.$vux.loading.show({
    text: '加载中'
  })*/
  Toast.loading({
    mask: true,
    duration: 0,
    message: '加载中...'
  })
  return config;
});

// 响应拦截
axios.interceptors.response.use(config => {
  // Vue.$vux.loading.hide()
  Toast.clear();
  return config;
});

function getApiUrl(url, host = "api.parkingfj") {
  const isDev = process.env.NODE_ENV === "development";
  if (isDev) {
    // return '/api' + url
    //  return `http://192.168.0.216:9002${url}`
    return `http://eipp.drboss.cn:5171/${url}`
  } else {
    // return `http://127.0.0.1:5171/${url}`
    return `http://eipp.drboss.cn:5171/${url}`
  }
}
export function request({ url, method, data, host, header }) {
  let requestParams = {
    url: getApiUrl(url, host),
    method: method || "post",
    withCredentials: true,
    headers: {
      "Content-Type": header || "application/x-www-form-urlencoded"
    }
  };
  if (
    requestParams.method === "post" &&
    JSON.stringify(requestParams.headers) ===
      '{"Content-Type":"application/x-www-form-urlencoded"}'
  ) {
    requestParams.data = qs.stringify(data);
  } else if (
    requestParams.method === "post" &&
    JSON.stringify(requestParams.headers) !=
      '{"Content-Type":"application/x-www-form-urlencoded"}'
  ) {
    requestParams.data = JSON.stringify(data);
  } else if (requestParams.method === "get") {
    requestParams.params = data;
  }
  return new Promise((resolve, reject) => {
    axios(requestParams).then(
      res => {
        let resMsg = res.data;
        if (resMsg.status === "S") {
          resolve(resMsg.data);
        } else if (resMsg.status === "F") {
          Dialog.alert({
            title: "提示",
            message: resMsg.msg
          });
          reject(resMsg.msg);
        }
        //  else if (resMsg.status === "T") {
        //   window.location.href = "/login";
        // }
      },
      errMsg => {
        reject(errMsg);
      }
    );
  });
}



// WEBPACK FOOTER //
// ./src/util/request.js